webpackJsonp([5],{

/***/ 114:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(83);

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__(86);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(84);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _axios = __webpack_require__(148);

var _axios2 = _interopRequireDefault(_axios);

var _elementUi = __webpack_require__(69);

var _store = __webpack_require__(18);

var _store2 = _interopRequireDefault(_store);

var _router = __webpack_require__(68);

var _router2 = _interopRequireDefault(_router);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var instance = _axios2.default.create({
    withCredentials: true,

    timeout: 50000
});

instance.interceptors.request.use(function () {
    var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(config) {
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        config.headers["requestClient"] = "YEZI_PC";

                        if (!(config.url.indexOf("/user/") < 0)) {
                            _context.next = 7;
                            break;
                        }

                        _context.next = 4;
                        return $util.security.isLogin();

                    case 4:
                        return _context.abrupt('return', config);

                    case 7:
                        return _context.abrupt('return', config);

                    case 8:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function (_x) {
        return _ref.apply(this, arguments);
    };
}(), function (error) {
    loadinginstace.close();
    _elementUi.Message.error({
        message: '加载超时'
    });
    return _promise2.default.reject(error);
});

instance.interceptors.response.use(function (resp) {
    return resp;
}, function (error) {
    if (error.response) {
        switch (error.response.status) {
            case 308:
                var redirectUrl = error.response.headers['authentication-redirecturl'];
                if (redirectUrl) {
                    window.location.href = redirectUrl;
                }
                break;

            case 401:
                document.cookie = "_authenticationTokenValue=''" + ';expires=' + new Date(0).toUTCString() + ';domain=' + $util.security.getDomain() + ';' + 'path=/';
                document.cookie = "AuthInfo=''" + ';expires=' + new Date(0).toUTCString() + ';domain=' + $util.security.getDomain() + ';' + 'path=/';
                _store2.default.dispatch('clearGlobal');
                _store2.default.dispatch('clearHeadTab');
                _store2.default.dispatch('clearInclude');
                _store2.default.dispatch('clearRecords');
                _router2.default.push({ name: "login" });
                break;

            case 403:
                (0, _elementUi.Message)({
                    message: "Sorry,you do not have permission for access this resource",
                    type: 'info',
                    customClass: "http-error-class",
                    iconClass: "el-icon-info",
                    duration: 5 * 1000
                });
                break;

            case 404:
                (0, _elementUi.Message)({
                    message: "Sorry,the resource is not found",
                    type: 'info',
                    customClass: "http-error-class",
                    iconClass: "el-icon-info",
                    duration: 5 * 1000
                });
                break;

            case 400:
            case 422:
                (0, _elementUi.Message)({
                    message: error.response.data.message,
                    type: 'info',
                    customClass: "http-error-class",
                    iconClass: "el-icon-info",
                    duration: 5 * 1000
                });
                break;
            case 500:
                (0, _elementUi.Message)({
                    message: error.response.data.message,
                    type: 'info',
                    customClass: "http-error-class",
                    iconClass: "el-icon-info",
                    duration: 5 * 1000
                });
                break;
            default:
                (0, _elementUi.Message)({
                    message: "Sorry, server error.",
                    type: 'info',
                    customClass: "http-error-class",
                    iconClass: "el-icon-info",
                    duration: 5 * 1000
                });
                break;
        }
    }
    return _promise2.default.reject(error);
});

exports.default = instance;

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(82);

var _assign2 = _interopRequireDefault(_assign);

var _vue = __webpack_require__(1);

var _vue2 = _interopRequireDefault(_vue);

var _vueI18n = __webpack_require__(268);

var _vueI18n2 = _interopRequireDefault(_vueI18n);

var _locale = __webpack_require__(34);

var _locale2 = _interopRequireDefault(_locale);

var _id = __webpack_require__(234);

var _id2 = _interopRequireDefault(_id);

var _zhCN = __webpack_require__(104);

var _zhCN2 = _interopRequireDefault(_zhCN);

var _home_id = __webpack_require__(168);

var _home_id2 = _interopRequireDefault(_home_id);

var _table_data_id = __webpack_require__(170);

var _table_data_id2 = _interopRequireDefault(_table_data_id);

var _home_zhCN = __webpack_require__(169);

var _home_zhCN2 = _interopRequireDefault(_home_zhCN);

var _table_data_zhCN = __webpack_require__(171);

var _table_data_zhCN2 = _interopRequireDefault(_table_data_zhCN);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueI18n2.default);
var messages = {
    id: (0, _assign2.default)(_id2.default, _home_id2.default, _table_data_id2.default),
    zhCn: (0, _assign2.default)(_zhCN2.default, _home_zhCN2.default, _table_data_zhCN2.default)
};
var i18n = new _vueI18n2.default({
    locale: 'zhCn',
    fallbackLocale: 'zhCn',
    silentTranslationWarn: true,
    messages: messages
});
_locale2.default.i18n(function (key, value) {
    return i18n.t(key, value);
});

exports.default = i18n;

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(1);

var _vue2 = _interopRequireDefault(_vue);

var _store = __webpack_require__(18);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.mixin({
    methods: {
        clearStore: function clearStore() {
            _store2.default.dispatch('clearGlobal');
            _store2.default.dispatch('clearHeadTab');
            _store2.default.dispatch('clearInclude');
            _store2.default.dispatch('clearRecords');
        }
    }
});

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _security = __webpack_require__(180);

var _security2 = _interopRequireDefault(_security);

var _time = __webpack_require__(182);

var _time2 = _interopRequireDefault(_time);

var _page = __webpack_require__(179);

var _page2 = _interopRequireDefault(_page);

var _message = __webpack_require__(178);

var _message2 = _interopRequireDefault(_message);

var _string = __webpack_require__(181);

var _string2 = _interopRequireDefault(_string);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    security: _security2.default,
    time: _time2.default,
    page: _page2.default,
    message: _message2.default,
    string: _string2.default
};

/***/ }),

/***/ 118:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 119:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 120:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 121:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(247)

var Component = __webpack_require__(71)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(269),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(248)

var Component = __webpack_require__(71)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(270),
  /* scopeId */
  "data-v-f4bdd810",
  /* cssModules */
  null
)

/* customBlocks */
var customBlock = __webpack_require__(125)
if (typeof customBlock === "function") {customBlock(Component)}


module.exports = Component.exports


/***/ }),

/***/ 125:
/***/ (function(module, exports) {

module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"id":{"search":"search"},"zhCn":{"search":"搜索菜单"}}')
}


/***/ }),

/***/ 166:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    name: 'app',
    components: {}
};

/***/ }),

/***/ 167:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(85);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _vuex = __webpack_require__(25);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'asideMenu',
    props: {
        showMenu: {
            type: Boolean,
            required: true
        }
    },
    data: function data() {
        return {
            realMenus: []
        };
    },

    computed: (0, _vuex.mapState)({
        menus: function menus(state) {
            return state.security.menus;
        }
    }),
    methods: {
        close: function close() {
            this.$emit('close');
        },
        over: function over() {
            this.$emit('over');
        },
        out: function out() {
            this.$emit('out');
        },
        search: function search(val) {
            var menus = [].concat((0, _toConsumableArray3.default)(this.menus));
            menus.filter(function (item) {});
        }
    },
    created: function created() {
        this.realMenus = this.menus;
        console.log(this.menus);
    }
};

/***/ }),

/***/ 168:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    home: {
        updatePwd: "Update Password",
        myMessage: "Informasi Saya",
        set: "Setting",
        switch: "Switch",
        logout: "Logout",
        loginName: "Nama Login",
        password: "Password",
        confirmPassword: "Konfirmasi Password",
        sure: "Yakin",
        filter: "Saring",
        confirmLogout: "Konfirmasi keluar?",
        tip: "prompt",
        basic: "basis",
        userInfo: "个人信息",
        companyName: "公司",
        employeeName: "姓名",
        officeName: "部门",
        positionName: "岗位",
        leaderName: "上级",
        regularDate: "转正日期",
        notify: "通知中心",
        dutySize: "待批考勤",
        auditFileSize: "待批文件",
        overtimeHour: "可用调休",
        annualHour: "可用调休年假",
        expiredHour: "即将过期",
        messageCount: "未读通知",
        assetAuditCount: "行政待审核",
        shopAd: "广告申请",
        regulashopAdDoorrDate: "制作广告",
        inputPassword: "Silakan Input Password",
        passwordReg: "密码长度6-16位,数字、字母、字符至少包含两种",
        inputConfirmPassword: "请输入确认密码",
        notSame: "两次输入密码不一致!"
    }
};

/***/ }),

/***/ 169:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    home: {
        updatePwd: "修改密码",
        myMessage: "我的消息",
        set: "设置",
        switch: "切换",
        logout: "退出登录",
        loginName: "登录名",
        password: "密码",
        confirmPassword: "确认密码",
        sure: "确认",
        filter: "过滤",
        confirmLogout: "确认退出吗?",
        tip: "提示",
        basic: "基础",
        userInfo: "个人信息",
        companyName: "公司",
        employeeName: "姓名",
        officeName: "部门",
        positionName: "岗位",
        leaderName: "上级",
        regularDate: "转正日期",
        notify: "通知中心",
        dutySize: "待批考勤",
        auditFileSize: "待批文件",
        overtimeHour: "可用调休",
        annualHour: "可用调休年假",
        expiredHour: "即将过期",
        messageCount: "未读通知",
        assetAuditCount: "行政待审核",
        recruitApplyCount: "待批招聘申请",
        shopAd: "广告申请",
        regulashopAdDoorrDate: "制作广告",
        inputPassword: "请输入密码",
        passwordReg: "密码长度6-16位,数字、字母、字符至少包含两种",
        inputConfirmPassword: "请输入确认密码",
        notSame: "两次输入密码不一致!"
    }
};

/***/ }),

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
        value: true
});
exports.default = {
        menus: {
                backend: {
                        basicManager: "Manajemen Basic",
                        businessManager: "Manajemen Penjualan",
                        cloudManager: "Manajemen 金蝶K3",
                        factoryManager: "Ikatan Dengan Pabrik",
                        assetManager: "行政中心",
                        reportManager: "报表管理"
                },
                backendModule: {
                        basicSysModule: "Sistem",
                        basicHrModule: "HRD",
                        basicSalaryModule: "Gaji",
                        businessBasicModule: "Basic",
                        systemBasicModule: "系统服务",
                        operatorsModule: "operators",
                        businessWorkModule: "Bisnis",
                        businessPlanningModule: "Planning",
                        businessReportModule: "Laporan",
                        cloudReportModule: "Laporan",
                        cloudInputModule: "Nota Input",
                        cloudSysModule: "sistem",
                        factoryBasicModule: "Basic",
                        businessFutureModule: "订货",
                        businessLogisticsModule: "物流仓储",
                        businessProductModule: "商品中心",
                        businessImeModule: "串码",
                        businessCustomerModule: "渠道中心",
                        businessPerformanceModule: "考核激励",
                        businessAdvertisingModule: "终端企划",
                        businessAftersalesModule: "售后",
                        businessTrainingModule: "培训",
                        businessToolModule: "工厂对接",
                        basicDutyModule: "勤务服务",
                        basicEmployeeModule: "员工服务",
                        basicAccountModule: "账户服务",
                        basicRecruitModule: "招聘服务",
                        supportBasicModule: "业务基础",
                        assetAssetModule: "资产模块",
                        assetMessageModule: "消息中心",
                        assetServiceModule: "后勤服务",
                        cloudModule: "金蝶管理",
                        reportModule: "报表管理",
                        hrCooperationModule: "协同服务",
                        businessDistributionModule: "分货"
                },
                menuCategory: {
                        hrCategory: "Manajemen SDM",
                        sysCategory: "Pengaturan Sistem",
                        saleCategory: "Manajemen Penjualan",
                        apiCategory: "Interface Eksternal",
                        menusCategory: "Menu",
                        officeCategory: "Struktur Organisasi",
                        dictCategory: "Kamus",
                        permissionCategory: "Otoritas",
                        fileCategory: "File",
                        dutyCategory: "Manajemen duty",
                        workStreamCategory: "Alur Kerja",
                        taskCenterCategory: "Pusat Persetujuan File",
                        accountAboutCategory: "Karyawan",
                        salaryCategory: "Manajemen Upah",
                        productImeCategory: "String Kode Barang",
                        goodsOrderCategory: "Manajemen Pemesanan barang",
                        baseCategory: "Informasi Dasar",
                        adCategory: "Material Iklan",
                        customerCategory: "Pusat Service Center",
                        afterSaleCategory: "Manajemen Service Center",
                        saleReportCategory: "Laporan Penjualan",
                        k3CloudCategory: "K3Cloud",
                        b2bCategory: "Mall Online",
                        oppoDataCategory: "Data OPPO",
                        dataManagerCategory: "Manajemen Data",
                        vivoDataCategory: "Data vivo",
                        djDataCategory: "Data E-Education",
                        taskPolicyCategory: "Kebijakan Misi",
                        commissionCategory: "Komisi Standar",
                        reportCategory: "Pusat Laporan",
                        cloudBatchBillCategory: "Batch Input",
                        cloudReportCategory: "Laporan Finance",
                        cloudSysCategory: "Setting Sistem"
                }
        }
};

/***/ }),

/***/ 171:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
          value: true
});
exports.default = {
          menus: {
                    backend: {
                              basicManager: "人事中心",
                              businessManager: "业务管理",
                              cloudManager: "财务中心",
                              factoryManager: "工厂对接",
                              assetManager: "行政中心",
                              reportManager: "报表管理"
                    },
                    backendModule: {
                              basicSysModule: "系统",
                              basicHrModule: "人事",
                              basicSalaryModule: "薪资",
                              businessBasicModule: "基础",
                              systemBasicModule: "系统服务",
                              businessWorkModule: "业务",
                              businessPlanningModule: "企划",
                              businessReportModule: "报表",
                              operatorsModule: "运营商服务",
                              cloudReportModule: "报表",
                              cloudInputModule: "录单",
                              cloudSysModule: "系统",
                              factoryBasicModule: "基础",
                              businessFutureModule: "订货",
                              businessProductModule: "商品中心",
                              businessLogisticsModule: "物流仓储",
                              businessImeModule: "串码",
                              businessCustomerModule: "渠道中心",
                              businessPerformanceModule: "考核激励",
                              businessAdvertisingModule: "终端企划",
                              businessAftersalesModule: "售后",
                              businessTrainingModule: "培训",
                              businessToolModule: "工厂对接",
                              basicDutyModule: "勤务服务",
                              basicEmployeeModule: "员工服务",
                              basicAccountModule: "账户服务",
                              basicRecruitModule: "招聘服务",
                              supportBasicModule: "业务基础",
                              assetAssetModule: "资产模块",
                              assetMessageModule: "消息中心",
                              assetServiceModule: "后勤服务",
                              cloudModule: "金蝶管理",
                              reportModule: "报表管理",
                              hrCooperationModule: "协同服务",
                              businessDistributionModule: "分货"
                    },
                    menuCategory: {
                              hrCategory: "人事管理",
                              sysCategory: "系统设置",
                              saleCategory: "销售管理",
                              apiCategory: "外部接口",
                              menusCategory: "菜单",
                              officeCategory: "组织机构",
                              dictCategory: "字典",
                              permissionCategory: "权限",
                              fileCategory: "文件",
                              dutyCategory: "勤务管理",
                              workStreamCategory: "工作流",
                              taskCenterCategory: "任务中心",
                              accountAboutCategory: "员工相关",
                              salaryCategory: "工资管理",
                              productImeCategory: "货品串码",
                              baseCategory: "基础资料",
                              adCategory: "物料广告",
                              customerCategory: "客服中心",
                              afterSaleCategory: "售后管理",
                              saleReportCategory: "销售报表",
                              k3CloudCategory: "K3Cloud",
                              b2bCategory: "移动商城",
                              oppoDataCategory: "OPPO数据",
                              dataManagerCategory: "数据管理",
                              vivoDataCategory: "vivo数据",
                              djDataCategory: "dj数据",
                              taskPolicyCategory: "任务政策",
                              commissionCategory: "提成基准",
                              reportCategory: "报表中心",
                              cloudBatchBillCategory: "批量录入",
                              cloudReportCategory: "财务报表",
                              cloudRetailReportCategory: "零售报表",
                              cloudSysCategory: "系统设置",
                              cloudBaseCategory: "基础管理",
                              cloudCenterCategory: "个人中心",
                              goodsOrderCategory: "订货管理"
                    }
          }
};

/***/ }),

/***/ 172:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(1);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(123);

var _App2 = _interopRequireDefault(_App);

var _elementUi = __webpack_require__(69);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(119);

__webpack_require__(118);

var _vueRouter = __webpack_require__(70);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _store = __webpack_require__(18);

var _store2 = _interopRequireDefault(_store);

var _i18n = __webpack_require__(115);

var _i18n2 = _interopRequireDefault(_i18n);

var _vuex = __webpack_require__(25);

var _vuex2 = _interopRequireDefault(_vuex);

__webpack_require__(120);

var _router = __webpack_require__(68);

var _router2 = _interopRequireDefault(_router);

var _http = __webpack_require__(114);

var _http2 = _interopRequireDefault(_http);

var _mixin = __webpack_require__(116);

var _mixin2 = _interopRequireDefault(_mixin);

__webpack_require__(121);

var _qs = __webpack_require__(122);

var _qs2 = _interopRequireDefault(_qs);

var _util = __webpack_require__(117);

var _util2 = _interopRequireDefault(_util);

var _asideMenu = __webpack_require__(124);

var _asideMenu2 = _interopRequireDefault(_asideMenu);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_elementUi2.default);
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vuex2.default);

_vue2.default.component('aside-menu', _asideMenu2.default);

window.$qs = _qs2.default;
window.$http = _http2.default;
window.$util = _util2.default;
window.$mixin = _mixin2.default;

new _vue2.default({
  i18n: _i18n2.default,
  router: _router2.default,
  store: _store2.default,
  render: function render(h) {
    return h(_App2.default);
  }
}).$mount('#app');

/***/ }),

/***/ 173:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var login = function login(r) {
    return __webpack_require__.e/* require.ensure */(1).then((function () {
        return r(__webpack_require__(278));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var notFound = function notFound(r) {
    return __webpack_require__.e/* require.ensure */(2).then((function () {
        return r(__webpack_require__(275));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var home = function home(r) {
    return __webpack_require__.e/* require.ensure */(0).then((function () {
        return r(__webpack_require__(276));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};
var index = function index(r) {
    return __webpack_require__.e/* require.ensure */(3).then((function () {
        return r(__webpack_require__(277));
    }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
};

var routes = [{ path: '/404', component: notFound, name: 'notFound' }, { path: '/', component: home, name: 'home' }, { path: '/login', redirect: { name: 'home' } }];

exports.default = routes;

/***/ }),

/***/ 174:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var getLatestGoodsOrderBillDate = function getLatestGoodsOrderBillDate() {
    return window.localStorage.getItem("latestGoodsOrderBillDate");
};
var getLatestShipStatus = function getLatestShipStatus() {
    return window.localStorage.getItem('getLatestShipStatus');
};

exports.default = {
    state: {
        latestGoodsOrderBillDate: getLatestGoodsOrderBillDate(),
        latestShipStatus: getLatestShipStatus()
    },
    mutations: {
        setLatestGoodsOrderBillDate: function setLatestGoodsOrderBillDate(state, latestGoodsOrderBillDate) {
            localStorage.setItem('latestGoodsOrderBillDate', latestGoodsOrderBillDate);
            state.latestGoodsOrderBillDate = latestGoodsOrderBillDate;
        },
        setLatestShipStatus: function setLatestShipStatus(state, latestShipStatus) {
            localStorage.setItem('latestShipStatus', latestShipStatus);
            state.latestShipStatus = latestShipStatus;
        }
    },
    actions: {
        setLatestGoodsOrderBillDate: function setLatestGoodsOrderBillDate(_ref, latestGoodsOrderBillDate) {
            var commit = _ref.commit,
                state = _ref.state;

            commit('setLatestGoodsOrderBillDate', latestGoodsOrderBillDate);
        },
        setLatestShipStatus: function setLatestShipStatus(_ref2, latestShipStatus) {
            var commit = _ref2.commit,
                state = _ref2.state;

            commit('setLatestShipStatus', latestShipStatus);
        },
        clearRecords: function clearRecords(_ref3) {
            var commit = _ref3.commit,
                state = _ref3.state;

            commit('setLatestGoodsOrderBillDate', null);
            commit('setLatestShipStatus', null);
        }
    }
};

/***/ }),

/***/ 175:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    state: {
        tabs: [],
        activeTab: ""
    },
    mutations: {
        setTabs: function setTabs(state, tabs) {
            state.tabs = tabs;
        },
        setActiveTab: function setActiveTab(state, activeTab) {
            state.activeTab = activeTab;
        }
    },
    actions: {
        addTab: function addTab(_ref, tab) {
            var commit = _ref.commit,
                state = _ref.state;

            var tabs = state.tabs;
            var existRouter = false;
            for (var index in tabs) {
                var tabItem = tabs[index];
                if (tabItem.name == tab.name) {
                    existRouter = true;
                }
            }
            if (!existRouter) {
                tabs.push(tab);
                if (tabs.length >= 10) {
                    tabs = tabs.splice(tabs.length - 10);
                }
                commit('setTabs', tabs);
            }
        },
        deleteTab: function deleteTab(_ref2, routerName) {
            var commit = _ref2.commit,
                state = _ref2.state;

            var tabs = state.tabs;
            for (var index in tabs) {
                var tabItem = tabs[index];
                if (tabItem.name == routerName) {
                    tabs.splice(index, 1);
                    commit('setTabs', tabs);
                    break;
                }
            }
        },
        setActiveTab: function setActiveTab(_ref3, activeTab) {
            var commit = _ref3.commit,
                state = _ref3.state;

            commit('setActiveTab', activeTab);
        },
        clearHeadTab: function clearHeadTab(_ref4) {
            var commit = _ref4.commit,
                state = _ref4.state;

            commit('setTabs', []);
            commit('setActiveTab', "");
        }
    }
};

/***/ }),

/***/ 176:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    state: {
        include: []
    },
    mutations: {
        setInclude: function setInclude(state, include) {
            state.include = include;
        }
    },
    actions: {
        addKeepAlive: function addKeepAlive(_ref, includeItem) {
            var commit = _ref.commit,
                state = _ref.state;

            var include = state.include;
            for (var index in include) {
                if (include[index] == includeItem) {
                    return;
                }
            }
            include.push(includeItem);
            commit('setInclude', include);
        },
        deleteKeepAlive: function deleteKeepAlive(_ref2, includeItem) {
            var commit = _ref2.commit,
                state = _ref2.state;

            var include = state.include;
            for (var index in include) {
                if (include[index] == includeItem) {
                    include.splice(index, 1);
                    commit('setInclude', include);
                    break;
                }
            }
        },
        clearInclude: function clearInclude(_ref3) {
            var commit = _ref3.commit,
                state = _ref3.state;

            commit('setInclude', []);
        }
    }
};

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(42);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getLang = function getLang() {
    var local = window.localStorage.getItem("lang");
    if (!local) {
        local = "zhCn";
    }
    return local;
};

var getMenus = function getMenus() {
    var local = window.localStorage.getItem("menus");
    if (local) {
        local = JSON.parse(local);
    } else {
        local = [];
    }
    return local;
};

var getAccount = function getAccount() {
    var local = window.localStorage.getItem("account");
    if (local) {
        local = JSON.parse(local);
    } else {
        local = {};
    }
    return local;
};

var getAuthorityList = function getAuthorityList() {
    var local = window.localStorage.getItem("authorityList");
    if (local) {
        local = JSON.parse(local);
    } else {
        local = {};
    }
    return local;
};

var getExpiresDate = function getExpiresDate() {
    var local = window.localStorage.getItem("expiresDate");
    return local;
};

var getAccessToken = function getAccessToken() {
    var local = window.localStorage.getItem("accessToken");
    return local;
};

var getRefreshToken = function getRefreshToken() {
    var local = window.localStorage.getItem("refreshToken");
    return local;
};

var getCurrentBusinessLine = function getCurrentBusinessLine() {
    var local = window.localStorage.getItem("currentBusinessLine");
    return local;
};

exports.default = {
    state: {
        menus: getMenus(),
        account: getAccount(),
        authorityList: getAuthorityList(),
        lang: getLang(),
        expiresDate: getExpiresDate(),
        accessToken: getAccessToken(),
        refreshToken: getRefreshToken(),
        currentBusinessLine: getCurrentBusinessLine()
    },
    mutations: {
        setMenus: function setMenus(state, menus) {
            localStorage.setItem('menus', (0, _stringify2.default)(menus));
            state.menus = menus;
        },
        setExpiresDate: function setExpiresDate(state, expiresDate) {
            localStorage.setItem('expiresDate', expiresDate);
            state.expiresDate = expiresDate;
        },
        setAccessToken: function setAccessToken(state, accessToken) {
            localStorage.setItem('accessToken', accessToken);
            state.accessToken = accessToken;
        },
        setRefreshToken: function setRefreshToken(state, refreshToken) {
            localStorage.setItem('refreshToken', refreshToken);
            state.refreshToken = refreshToken;
        },
        setAccount: function setAccount(state, account) {
            localStorage.setItem('account', (0, _stringify2.default)(account));
            state.account = account;
        },
        setAuthorityList: function setAuthorityList(state, authorityList) {
            localStorage.setItem('authorityList', (0, _stringify2.default)(authorityList));
            state.authorityList = authorityList;
        },
        setLang: function setLang(state, lang) {
            localStorage.setItem('lang', lang);

            state.lang = lang;
        },
        setCurrentBusinessLine: function setCurrentBusinessLine(state, currentBusinessLine) {
            localStorage.setItem('currentBusinessLine', currentBusinessLine);
            state.currentBusinessLine = currentBusinessLine;
        }
    },
    actions: {
        setLang: function setLang(_ref, lang) {
            var commit = _ref.commit,
                state = _ref.state;

            commit('setLang', lang);
        },
        setExpiresDate: function setExpiresDate(_ref2, expiresDate) {
            var commit = _ref2.commit,
                state = _ref2.state;

            commit('setExpiresDate', expiresDate);
        },
        setAccessToken: function setAccessToken(_ref3, accessToken) {
            var commit = _ref3.commit,
                state = _ref3.state;

            commit('setAccessToken', accessToken);
        },
        setRefreshToken: function setRefreshToken(_ref4, refreshToken) {
            var commit = _ref4.commit,
                state = _ref4.state;

            commit('setRefreshToken', refreshToken);
        },
        setMenus: function setMenus(_ref5, menus) {
            var commit = _ref5.commit,
                state = _ref5.state;

            commit('setMenus', menus);
        },
        setAccount: function setAccount(_ref6, account) {
            var commit = _ref6.commit,
                state = _ref6.state;

            commit('setAccount', account);
        },
        setAuthorityList: function setAuthorityList(_ref7, authorityList) {
            var commit = _ref7.commit,
                state = _ref7.state;

            commit('setAuthorityList', authorityList);
        },
        setCurrentBusinessLine: function setCurrentBusinessLine(_ref8, businessLine) {
            var commit = _ref8.commit,
                state = _ref8.state;

            commit('setCurrentBusinessLine', businessLine);
        },
        clearGlobal: function clearGlobal(_ref9) {
            var commit = _ref9.commit,
                state = _ref9.state;

            commit('setMenus', []);
            commit('setExpiresDate', null);
            commit('setAccessToken', '');
            commit('setRefreshToken', '');
            commit('setAccount', {});
            commit('setAuthorityList', []);
            commit('setCurrentBusinessLine', null);
        }
    }
};

/***/ }),

/***/ 178:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(42);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var util = {};

util.toLocale = function (instance, data) {
    var i18n = instance.$i18n;
    var result = getItem(i18n, data.code, data.params);
    if (data.items.length > 0) {
        for (var index in data.items) {
            var item = data.items[index];
            var itemResult = getItem(i18n, item.code, item.params);
            if (itemResult != "") {
                result = result + "<br/>" + itemResult;
            }
        }
    }
    return result;
};

function getItem(i18n, code, params) {
    var result = "";
    if (code != null && code != "") {
        if ((0, _stringify2.default)(params) == "{}") {
            result = i18n.t(code, params);
        } else {
            result = i18n.t(code);
        }
    }
    return result;
}

exports.default = util;

/***/ }),

/***/ 179:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(73);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _stringify = __webpack_require__(42);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var util = {};

util.deleteExtra = function (json) {
    var newJson = JSON.parse((0, _stringify2.default)(json));
    delete newJson.extra;
    return newJson;
};

util.getSort = function (column) {
    var sort = '';
    if (column.prop == null) {
        sort = "id,DESC";
    } else {
        var order = "DESC";
        if (column.order == "ascending") {
            order = "ASC";
        }
        if (column.column.columnKey != null) {
            sort = column.column.columnKey + "," + order;
        } else {
            sort = column.prop + "," + order;
        }
    }
    return sort;
};

util.copyValue = function (from, to) {
    if (from != null) {
        for (var key in to) {
            if (from[key] != null) {
                to[key] = from[key];
            }
        }
    }
};

util.confirmBeforeDelRecord = function (vueObj) {
    return vueObj.$confirm(vueObj.$t('util.waringMsgBeforeDelRecord'), vueObj.$t('util.notify'), {
        confirmButtonText: vueObj.$t('util.confirmButton'),
        cancelButtonText: vueObj.$t('util.cancelButton'),
        type: 'warning'
    });
};
util.confirmBeforeBatchPass = function (vueObj) {
    return vueObj.$confirm(vueObj.$t('util.waringMsgBeforeBatchPass'), vueObj.$t('util.notify'), {
        confirmButtonText: vueObj.$t('util.confirmButton'),
        cancelButtonText: vueObj.$t('util.cancelButton'),
        type: 'warning'
    });
};

util.confirmBeforeAction = function (vueObj, action) {
    return vueObj.$confirm(vueObj.$t('util.waringMsgBeforeAction'), vueObj.$t('util.notify'), {
        confirmButtonText: vueObj.$t('util.confirmButton'),
        cancelButtonText: vueObj.$t('util.cancelButton'),

        type: 'warning'
    });
};
util.confirmBeforeExportData = function (vueObj) {
    return vueObj.$confirm(vueObj.$t('util.waringMsgBeforeExportData'), vueObj.$t('util.notify'), {
        confirmButtonText: vueObj.$t('util.confirmButton'),
        cancelButtonText: vueObj.$t('util.cancelButton'),
        type: 'warning'
    });
};

util.confirmBefore = function (vueObj) {
    return vueObj.$confirm(vueObj.$t('util.confirmOperation'), vueObj.$t('util.notify'), {
        confirmButtonText: vueObj.$t('util.confirmButton'),
        cancelButtonText: vueObj.$t('util.cancelButton'),
        type: 'warning'
    });
};

util.getIdList = function (array) {
    var idList = new Array();
    if (array != null && array.length > 0) {
        for (var i = 0; i < array.length; i++) {
            idList.push(array[i].id);
        }
    }
    return idList;
};

util.getLabelList = function (array, labelColumn) {
    if (labelColumn == null) {
        labelColumn = "name";
    }
    var list = new Array();
    if (array != null && array.length > 0) {
        for (var index in array) {
            var obj = array[index];
            list.push(obj[labelColumn]);
        }
    }
    return list;
};

util.getFolderFileIdStr = function (array) {
    var idList = new Array();
    if (array != null && array.length > 0) {
        for (var i = 0; i < array.length; i++) {
            if (array[i].id != null) {
                idList.push(array[i].id);
            } else {
                if (array[i].response != null && array[i].response.length > 0 && array[i].response[0].id != null) {
                    idList.push(array[i].response[0].id);
                }
            }
        }
    }
    return idList.join();
};

util.numToFixed = function (num) {
    if (typeof num == 'number') {
        num = parseFloat(num.toFixed(7));
    }
    return num;
};

util.contextMenu = function (lang) {
    var menus = {
        items: {
            "row_above": {
                name: '插入行(上方)'
            },
            "row_below": {
                name: '插入行(下方)'
            },
            "remove_row": {
                name: "删除行"
            }
        }
    };
    if (lang === 'id') {
        return true;
    } else {
        return menus;
    }
};

util.getSelectedList = function (selected) {
    var idList = new Array();
    if (selected instanceof Array) {
        idList = selected;
    } else {
        if ($util.string.isNotBlank(selected)) {
            idList.push(selected);
        }
    }
    return idList;
};

util.mergeSelectList = function (selectedIdList, localList, remoteList) {
    var newList = new Array();
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = (0, _getIterator3.default)(localList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            if (selectedIdList.indexOf(item.id) >= 0) {
                newList.push(item);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;

    try {
        for (var _iterator2 = (0, _getIterator3.default)(remoteList), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var item = _step2.value;

            if (selectedIdList.indexOf(item.id) < 0) {
                newList.push(item);
            }
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
                _iterator2.return();
            }
        } finally {
            if (_didIteratorError2) {
                throw _iteratorError2;
            }
        }
    }

    return newList;
};

exports.default = util;

/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _vue = __webpack_require__(1);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(25);

var _vuex2 = _interopRequireDefault(_vuex);

var _security = __webpack_require__(177);

var _security2 = _interopRequireDefault(_security);

var _headTab = __webpack_require__(175);

var _headTab2 = _interopRequireDefault(_headTab);

var _keeper = __webpack_require__(176);

var _keeper2 = _interopRequireDefault(_keeper);

var _global = __webpack_require__(174);

var _global2 = _interopRequireDefault(_global);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
    modules: {
        security: _security2.default,
        headTab: _headTab2.default,
        keeper: _keeper2.default,
        global: _global2.default
    }
});

/***/ }),

/***/ 180:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(73);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _regenerator = __webpack_require__(86);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(84);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

exports.DomainParser = DomainParser;

var _store = __webpack_require__(18);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var util = {};

var is_refresh_token = false;

util.isPermit = function (permissionName) {
    var authorityList = _store2.default.state.security.authorityList;
    if (authorityList && authorityList.indexOf(permissionName) != -1) {
        return true;
    }
    return false;
};

util.refreshAccessToken = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
    var accessToken, refreshToken, expiresDate, isRefreshToken, permit;
    return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    accessToken = _store2.default.state.security.accessToken;
                    refreshToken = _store2.default.state.security.refreshToken;
                    expiresDate = _store2.default.state.security.expiresDate;
                    isRefreshToken = false;

                    if (!(accessToken && refreshToken && !is_refresh_token)) {
                        _context.next = 19;
                        break;
                    }

                    is_refresh_token = true;
                    _context.next = 8;
                    return $http.post('/user/refreshToken', $qs.stringify({ accessToken: accessToken, refreshToken: refreshToken, expiresDate: expiresDate }));

                case 8:
                    permit = _context.sent;

                    console.log('3', permit);
                    _store2.default.dispatch('setExpiresDate', permit.data.expiresDate);
                    _store2.default.dispatch('setAccessToken', permit.data.accessToken);
                    _store2.default.dispatch('setRefreshToken', permit.data.refreshToken);
                    is_refresh_token = false;
                    isRefreshToken = permit.data.isRefreshToken;
                    console.log("isRefreshToken", isRefreshToken);
                    return _context.abrupt('return', isRefreshToken);

                case 19:
                    return _context.abrupt('return', setTimeout(function () {
                        return true;
                    }, 1000));

                case 20:
                case 'end':
                    return _context.stop();
            }
        }
    }, _callee, this);
}));

util.isLogin = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
    var expiresDate;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    this.initAuthInfo();
                    expiresDate = _store2.default.state.security.expiresDate;

                    if (!(!expiresDate || expiresDate === 'null')) {
                        _context2.next = 8;
                        break;
                    }

                    _context2.next = 5;
                    return this.refreshAccessToken();

                case 5:
                    return _context2.abrupt('return', _context2.sent);

                case 8:
                    if (!(Date.parse(new Date()) / 1000 < expiresDate - 600)) {
                        _context2.next = 12;
                        break;
                    }

                    return _context2.abrupt('return', true);

                case 12:
                    _context2.next = 14;
                    return this.refreshAccessToken();

                case 14:
                    return _context2.abrupt('return', _context2.sent);

                case 15:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _callee2, this);
}));

util.initAuthInfo = function () {
    var cookie = document.cookie;
    if (cookie && cookie != 'null') {
        var cookieList = cookie.split(";");
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = (0, _getIterator3.default)(cookieList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var value = _step.value;

                if (value.trim().startsWith("AuthInfo") > 0) {
                    var authInfo = '';

                    try {
                        authInfo = decodeURIComponent(value);
                    } catch (error) {}
                    authInfo = authInfo.substring(authInfo.indexOf("=") + 1, authInfo.length);
                    try {
                        authInfo = JSON.parse(authInfo) || {};
                    } catch (error) {}
                    _store2.default.dispatch("setExpiresDate", authInfo.accessTokenExpiration);
                    _store2.default.dispatch("setAccessToken", authInfo.accessTokenValue);
                    _store2.default.dispatch("setRefreshToken", authInfo.refreshTokenValue);
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
};

util.getDomain = function () {
    var Domain = document.domain;
    var parser = new DomainParser(Domain);
    parser.parse();
    if (!parser.hasError()) {
        Domain = '.' + parser.getModifyName();
    }
    return Domain;
};

function DomainParser(domainName) {
    var input = domainName;
    var modifyName = domainName;
    var b_error = false;
    var message = "";

    DomainParser.prototype.parse = function () {
        if (!input || input.length == 0) {
            failMessage('请填写域名，例如：sojson.com');
            return;
        }
        var labels = parseLabels();
        if (hasError()) {
            return;
        }
        if (labels.length == 1) {
            failMessage('域名格式错误。请输入正确的域名格式，以“.”进行区分 ');
            return;
        }
        var topLabel = labels[labels.length - 1];
        if (isDigitLabels(topLabel)) {
            failMessage("域名格式错误。请输入正确的域名格式，以“.”进行区分 ");
            return;
        }
        if (input.length > 255) {
            failMessage('域名过长。每标号不得超过63个字符。由多个标号组成的完整域名总共不超过255个字符。');
            return;
        }
        var topLevel = parseTopLevel(labels);
        if (topLevel.labelIndex == 0) {
            failMessage(topLevel.name + '是域名后缀，不能查询。');
            return;
        }
        var secondLevel = parseSecondLevel(labels, topLevel);
        if (secondLevel.labelIndex != 0 && topLevel.recognized) {
            modifyName = secondLevel.name + "." + topLevel.name;
        }
    };

    DomainParser.prototype.getModifyName = function () {
        return modifyName;
    };

    function hasError() {
        return b_error;
    }

    DomainParser.prototype.hasError = hasError;
    DomainParser.prototype.getMessage = function () {
        if (hasError()) {
            return message;
        } else {
            return null;
        }
    };

    function parseLabels() {
        var labels = new Array();
        var offset = 0;
        while (offset < input.length) {
            var label = parseLabel();
            if (!hasError() && label) {
                labels.push(label);
            } else {
                return;
            }
        }
        return labels;

        function parseLabel() {
            var labelArr = new Array();
            var start = offset;
            while (offset < input.length) {
                var ch = input.charAt(offset);
                var invalid = false;
                if (start == offset && !isLetterOrDigit(ch)) {
                    invalid = true;
                } else if ((offset + 1 == input.length || input.charAt(offset + 1) == '.') && !isLetterOrDigit(ch)) {
                    invalid = true;
                } else if (!isLabelChar(ch)) {
                    invalid = true;
                }
                if (invalid) {
                    failMessage('格式错误。域名一般由英文字母、汉字、阿拉伯数字、"-"组成，用“.”分隔，且每段不能以“.”、"-”开头和结尾');
                    return;
                } else {
                    labelArr.push(ch);
                    offset++;
                    if (offset < input.length && input.charAt(offset) == '.' || offset == input.length) {
                        if (offset < input.length && input.charAt(offset) == '.') {
                            offset++;
                        }
                        if (labelArr.length > 63) {
                            failMessage('域名过长。每标号不得超过63个字符。由多个标号组成的完整域名总共不超过255个字符。');
                            return;
                        }
                        return labelArr.join("");
                    }
                }
            }
        }
    }

    function isLabelChar(ch) {
        if (ch.charCodeAt(0) <= 127) {
            if (ch >= 'A' && ch <= 'Z' || ch >= 'a' && ch <= 'z' || ch >= '0' && ch <= '9' || ch == '-') {
                return true;
            } else {
                return false;
            }
        } else {
            if (ch.charCodeAt(0) >= 0xFF00 && ch.charCodeAt(0) <= 0xFFEF || ch.charCodeAt(0) >= 0x3000 && ch.charCodeAt(0) <= 0x303F) {
                return false;
            } else {
                return true;
            }
        }
    }

    function isLetterOrDigit(ch) {
        if (ch.charCodeAt(0) <= 127) {
            if (ch >= 'A' && ch <= 'Z' || ch >= 'a' && ch <= 'z' || ch >= '0' && ch <= '9') {
                return true;
            } else {
                return false;
            }
        } else {
            if (ch.charCodeAt(0) >= 0xFF00 && ch.charCodeAt(0) <= 0xFFEF || ch.charCodeAt(0) >= 0x3000 && ch.charCodeAt(0) <= 0x303F) {
                return false;
            } else {
                return true;
            }
        }
    }

    function isDigitLabels(label) {
        var i = 0;
        while (i < label.length) {
            var ch = label.charAt(i);
            if (!(ch >= '0' && ch <= '9')) {
                return false;
            }
            i++;
        }
        return true;
    }

    function parseTopLevel(labels) {
        var topLevelName = "";
        var lowTopLevelName = "";
        var topLevel;
        var index;
        if (labels.length >= 2) {
            topLevelName = labels[labels.length - 2] + "." + labels[labels.length - 1];
            lowTopLevelName = topLevelName.toLowerCase();
            for (index = 0; index < tow_top_level.length; index++) {
                if (lowTopLevelName == tow_top_level[index]) {
                    topLevel = new TopLevel(topLevelName, 2, labels.length - 2, true);
                    break;
                }
            }
        }
        if (!topLevel) {
            topLevelName = labels[labels.length - 1];
            lowTopLevelName = topLevelName.toLowerCase();
            for (index = 0; index < one_top_level.length; index++) {
                if (lowTopLevelName == one_top_level[index]) {
                    topLevel = new TopLevel(topLevelName, 1, labels.length - 1, true);
                    break;
                }
            }
        }
        if (!topLevel) {
            topLevelName = labels[labels.length - 1];
            topLevel = new TopLevel(topLevelName, 1, labels.length - 1, false);
        }
        return topLevel;
    }
    function TopLevel(name, labelCount, labelIndex, recognized) {
        this.name = name;
        this.labelCount = labelCount;
        this.labelIndex = labelIndex;
        this.recognized = recognized;
        return this;
    }

    function parseSecondLevel(labels, topLevel) {
        var secondLevel = new SecondLevel(labels[topLevel.labelIndex - 1], 1, topLevel.labelIndex - 1);
        return secondLevel;
    }

    function SecondLevel(name, labelCount, labelIndex) {
        this.name = name;
        this.labelCount = labelCount;
        this.labelIndex = labelIndex;
        return this;
    }

    function failMessage(msg) {
        message = msg;
        b_error = true;
    }

    var one_top_level = ['ac', 'ad', 'ae', 'aero', 'af', 'ag', 'ai', 'al', 'am', 'an', 'ao', 'aq', 'ar', 'arpa', 'as', 'asia', 'at', 'au', 'aw', 'ax', 'az', 'ba', 'bb', 'bd', 'be', 'bf', 'bg', 'bh', 'bi', 'biz', 'bj', 'bl', 'bm', 'bn', 'bo', 'bq', 'br', 'bs', 'bt', 'bv', 'bw', 'by', 'bz', 'ca', 'cat', 'cc', 'cd', 'cf', 'cg', 'ch', 'ci', 'ck', 'cl', 'cm', 'cn', 'co', 'com', 'coop', 'cr', 'cu', 'cv', 'cw', 'cx', 'cy', 'cz', 'de', 'dj', 'dk', 'dm', 'do', 'dz', 'ec', 'edu', 'ee', 'eg', 'eh', 'er', 'es', 'et', 'eu', 'fi', 'fj', 'fk', 'fm', 'fo', 'fr', 'ga', 'gb', 'gd', 'ge', 'gf', 'gg', 'gh', 'gi', 'gl', 'gm', 'gn', 'gov', 'gp', 'gq', 'gr', 'gs', 'gt', 'gu', 'gw', 'gy', 'hk', 'hm', 'hn', 'hr', 'ht', 'hu', 'id', 'ie', 'il', 'im', 'in', 'info', 'int', 'io', 'iq', 'ir', 'is', 'it', 'je', 'jm', 'jo', 'jobs', 'jp', 'ke', 'kg', 'kh', 'ki', 'km', 'kn', 'kp', 'kr', 'kw', 'ky', 'kz', 'la', 'lb', 'lc', 'li', 'lk', 'lr', 'ls', 'lt', 'lu', 'lv', 'ly', 'ma', 'mc', 'md', 'me', 'mf', 'mg', 'mh', 'mil', 'mk', 'ml', 'mm', 'mn', 'mo', 'mobi', 'mp', 'mq', 'mr', 'ms', 'mt', 'mu', 'museum', 'mv', 'mw', 'mx', 'my', 'mz', 'na', 'name', 'nc', 'ne', 'net', 'nf', 'ng', 'ni', 'nl', 'no', 'np', 'nr', 'nu', 'nz', 'om', 'org', 'pa', 'pe', 'pf', 'pg', 'ph', 'pk', 'pl', 'pm', 'pn', 'post', 'pr', 'pro', 'ps', 'pt', 'pw', 'py', 'qa', 're', 'ro', 'rs', 'ru', 'rw', 'sa', 'sb', 'sc', 'sd', 'se', 'sg', 'sh', 'si', 'sj', 'sk', 'sl', 'sm', 'sn', 'so', 'sr', 'ss', 'st', 'su', 'sv', 'sx', 'sy', 'sz', 'tc', 'td', 'tel', 'tf', 'tg', 'th', 'tj', 'tk', 'tl', 'tm', 'tn', 'to', 'tp', 'tr', 'travel', 'tt', 'tv', 'tw', 'tz', 'ua', 'ug', 'uk', 'um', 'us', 'uy', 'uz', 'va', 'vc', 've', 'vg', 'vi', 'vn', 'vu', 'wf', 'ws', '中国', '中國', '香港', '台湾', '台灣', '新加坡', 'xxx', 'ye', 'yt', 'za', 'zm', 'zw', 'zw', 'xn--fiqs8s', 'xn--fiqz9s', 'xn--j6w193g', 'xn--kprw13d', 'xn--kpry57d', 'xn--yfro4i67o', '公司', '网络', '網絡', 'xn--55qx5d', 'xn--io0a7i'];
    var tow_top_level = ['ac.cn', 'com.cn', 'edu.cn', 'gov.cn', 'mil.cn', 'net.cn', 'org.cn', 'bj.cn', 'sh.cn', 'tj.cn', 'cq.cn', 'he.cn', 'sx.cn', 'nm.cn', 'ln.cn', 'jl.cn', 'hl.cn', 'js.cn', 'zj.cn', 'ah.cn', 'fj.cn', 'jx.cn', 'sd.cn', 'ha.cn', 'hb.cn', 'hn.cn', 'gd.cn', 'gx.cn', 'hi.cn', 'sc.cn', 'gz.cn', 'yn.cn', 'xz.cn', 'sn.cn', 'gs.cn', 'qh.cn', 'nx.cn', 'xj.cn', 'tw.cn', 'hk.cn', 'mo.cn', 'com.af', 'net.af', 'org.af', 'com.ag', 'net.ag', 'org.ag', 'co.at', 'or.at', 'com.bi', 'edu.bi', 'info.bi', 'mo.bi', 'or.bi', 'org.bi', 'com.br', 'net.br', 'org.br', 'co.bz', 'com.bz', 'net.bz', 'org.bz', 'co.cm', 'com.cm', 'net.cm', 'com.co', 'net.co', 'nom.co', 'ar.com', 'br.com', 'cn.com', 'de.com', 'eu.com', 'gb.com', 'gr.com', 'hu.com', 'jpn.com', 'kr.com', 'no.com', 'ru.com', 'se.com', 'uk.com', 'us.com', 'za.com', 'com.de', 'co.dm', 'com.ec', 'fin.ec', 'info.ec', 'med.ec', 'net.ec', 'pro.ec', 'com.es', 'nom.es', 'org.es', 'co.gg', 'net.gg', 'org.gg', 'co.gl', 'com.gl', 'edu.gl', 'net.gl', 'org.gl', 'com.gr', 'co.gy', 'com.gy', 'net.gy', 'com.hk', 'edu.hk', 'gov.hk', 'idv.hk', 'net.hk', 'org.hk', 'com.hn', 'net.hn', 'org.hn', 'adult.ht', 'com.ht', 'info.ht', 'net.ht', 'org.ht', 'org.il', 'co.in', 'firm.in', 'gen.in', 'ind.in', 'net.in', 'org.in', 'bz.it', 'co.it', 'co.je', 'net.je', 'org.je', 'com.ki', 'net.ki', 'org.ki', 'co.kr', 'ne.kr', 'or.kr', 'pe.kr', 're.kr', 'seoul.kr', 'com.lc', 'net.lc', 'org.lc', 'co.mg', 'com.mg', 'net.mg', 'org.mg', 'ac.mu', 'co.mu', 'com.mu', 'net.mu', 'org.mu', 'com.mx', 'gb.net', 'hu.net', 'jp.net', 'se.net', 'uk.net', 'com.nf', 'net.nf', 'org.nf', 'co.nl', 'net.nz', 'org.nz', 'ae.org', 'us.org', 'com.pe', 'net.pe', 'org.pe', 'com.ph', 'com.pk', 'net.pk', 'org.pk', 'biz.pl', 'com.pl', 'info.pl', 'net.pl', 'org.pl', 'waw.pl', 'aaa.pro', 'aca.pro', 'acct.pro', 'avocat.pro', 'bar.pro', 'cpa.pro', 'eng.pro', 'jur.pro', 'law.pro', 'med.pro', 'recht.pro', 'com.ps', 'net.ps', 'org.ps', 'com.pt', 'edu.pt', 'org.pt', 'com.ru', 'net.sb', 'org.sb', 'com.sc', 'net.sc', 'org.sc', 'com.sg', 'com.so', 'net.so', 'org.so', 'club.tw', 'com.tw', 'ebiz.tw', 'game.tw', 'idv.tw', 'org.tw', 'me.uk', 'org.uk', 'co.uz', 'com.uz', 'com.vc', 'net.vc', 'org.vc', 'ac.vn', 'biz.vn', 'com.vn', 'edu.vn', 'gov.vn', 'health.vn', 'info.vn', 'int.vn', 'name.vn', 'net.vn', 'org.vn', 'pro.vn'];
}
exports.default = util;

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var util = {};
util.isBlank = function (val) {
    return _.trim(val) == "";
};

util.isNotBlank = function (val) {
    return _.trim(val) != "";
};

util.isEmpty = function (val) {
    return val == null || val.length == 0;
};

util.isNotEmpty = function (val) {
    return val != null && val.length > 0;
};

util.contains = function (str, subStr) {
    if (subStr == null || subStr.length == 0) {
        return true;
    }
    var reg = eval("/" + subStr + "/ig");
    return reg.test(str);
};

util.bool2str = function (value) {
    if (value == "true" || value == true || value == "1" || value == 1) {
        return "是";
    } else {
        return "否";
    }
};

util.auditStatus2color = function (status) {
    if (status == "未通过") {
        return "danger";
    } else if (status == "已通过") {
        return "success";
    } else {
        return "primary";
    }
};

exports.default = util;

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var util = {};

util.getFirstDayOfMonth = function (date) {
    date.setDate(1);
    return date;
};

util.addDay = function (date, qty) {
    var newDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    newDate.setDate(date.getDate() + qty);
    return newDate;
};

util.currentDate = function () {
    var myDate = new Date();
    return util.formatDate(myDate, "yyyy-MM-dd");
};

util.latestWeek = function () {
    var end = new Date();
    var start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
    return util.formatDate(start, "yyyy-MM-dd") + " - " + util.formatDate(end, "yyyy-MM-dd");
};

util.formatDateRange = function (dateRange) {
    if (dateRange != null && dateRange[0] != null && dateRange[1] != null) {
        return this.formatDate(new Date(dateRange[0]), "yyyy-MM-dd") + " - " + this.formatDate(new Date(dateRange[1]), "yyyy-MM-dd");
    } else {
        return "";
    }
};

util.formatLocalDate = function (date) {
    if (date != null && date != "") {
        return this.formatDate(new Date(date), "yyyy-MM-dd");
    } else {
        return "";
    }
};

util.formatLocalDateTime = function (date) {
    if (date != null && date != "") {
        return this.formatDate(new Date(date), "yyyy-MM-dd hh:mm:ss");
    } else {
        return "";
    }
};

util.formatLocalMonth = function (date) {
    if (date != null && date != "") {
        return this.formatDate(new Date(date), "yyyy-MM");
    } else {
        return "";
    }
};

util.formatDate = function (date, format) {
    var o = {
        "M+": date.getMonth() + 1,
        "d+": date.getDate(),
        "h+": date.getHours(),
        "m+": date.getMinutes(),
        "s+": date.getSeconds(),
        "q+": Math.floor((date.getMonth() + 3) / 3),
        "S": date.getMilliseconds() };
    if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
    }
    return format;
};

util.pickerDateOption = function (obj) {
    var shortcuts = {
        shortcuts: [{
            text: obj.$t('util.today'),
            onClick: function onClick(picker) {
                var end = new Date();
                var start = new Date();
                picker.$emit('pick', [start, end]);
            }
        }, {
            text: obj.$t('util.yesterday'),
            onClick: function onClick(picker) {
                var start = new Date();
                var end = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24);
                end.setTime(end.getTime() - 3600 * 1000 * 24);
                picker.$emit('pick', [start, end]);
            }
        }, {
            text: obj.$t('util.currentWeek'),
            onClick: function onClick(picker) {
                var now = new Date();
                var end = new Date();
                var start = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1 - now.getDay());
                end.getDay();
                picker.$emit('pick', [start, end]);
            }
        }, {
            text: obj.$t('util.currentMonth'),
            onClick: function onClick(picker) {
                var now = new Date();
                var day = new Date(now.getFullYear(), now.getMonth() + 1, 0);
                var start = new Date();
                var end = new Date();
                start.setDate(1);
                end.setDate(day.getDate());
                picker.$emit('pick', [start, end]);
            }
        }, {
            text: obj.$t('util.latestWeek'),
            onClick: function onClick(picker) {
                var end = new Date();
                var start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 6);
                end.setTime(end.getTime());
                picker.$emit('pick', [start, end]);
            }
        }, {
            text: obj.$t('util.latestMonth'),
            onClick: function onClick(picker) {
                var end = new Date();
                var start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 29);
                end.setTime(end.getTime());
                picker.$emit('pick', [start, end]);
            }
        }]
    };
    return shortcuts;
};

util.getAge = function (strBirthday) {
    var returnAge = void 0,
        strBirthdayArr = strBirthday.split("-");
    var birthYear = strBirthdayArr[0],
        birthMonth = strBirthdayArr[1],
        birthDay = strBirthdayArr[2];
    var day = new Date();
    var nowYear = day.getFullYear(),
        nowMonth = day.getMonth() + 1,
        nowDay = day.getDate();

    if (nowYear == birthYear) {
        returnAge = 0;
    } else {
        var ageDiff = nowYear - birthYear;
        if (ageDiff > 0) {
            if (nowMonth == birthMonth) {
                var dayDiff = nowDay - birthDay;
                if (dayDiff < 0) {
                    returnAge = ageDiff - 1;
                } else {
                    returnAge = ageDiff;
                }
            } else {
                var monthDiff = nowMonth - birthMonth;
                if (monthDiff < 0) {
                    returnAge = ageDiff - 1;
                } else {
                    returnAge = ageDiff;
                }
            }
        } else {
            returnAge = -1;
        }
    }
    return returnAge;
};

exports.default = util;

/***/ }),

/***/ 247:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 248:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 269:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 270:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "aside-menu-wrapper"
  }, [_c('div', {
    class: ['aside-menu', _vm.showMenu ? 'show' : ''],
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key)) { return null; }
        _vm.close($event)
      },
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        _vm.close($event)
      }
    }
  }, [_c('div', {
    staticClass: "aside-menu-menus"
  }, _vm._l((_vm.realMenus), function(item, index) {
    return _c('div', {
      staticClass: "menus-modules"
    }, [_c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(_vm.$t(("menus.backend." + (item.code)))))]), _vm._v(" "), _c('ul', {
      staticClass: "modules"
    }, _vm._l((item.backendModuleList), function(module) {
      return _c('li', {
        staticClass: "module"
      }, [_c('a', {
        key: module.code,
        attrs: {
          "href": module.path,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(_vm.$t(("menus.backendModule." + (module.code)))))])])
    }))])
  }))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMenu),
      expression: "showMenu"
    }],
    staticClass: "mask",
    on: {
      "click": _vm.close
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 272:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 68:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(85);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _vue = __webpack_require__(1);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(70);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _main_basic = __webpack_require__(173);

var _main_basic2 = _interopRequireDefault(_main_basic);

var _store = __webpack_require__(18);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var routes = [].concat((0, _toConsumableArray3.default)(_main_basic2.default));

var router = new _vueRouter2.default({
    routes: routes,
    base: "/asset/",
    mode: 'hash',
    linkActiveClass: 'active'
});

router.beforeEach(function (to, from, next) {
    var activeTab = _store2.default.state.headTab.activeTab;
    if (!activeTab || activeTab == "") {
        if (to.name && to.name != "" && !to.meta.disableTab) {
            _store2.default.dispatch("addTab", { name: to.name, query: to.query });
            _store2.default.dispatch("addKeepAlive", to.name);
            _store2.default.dispatch("setActiveTab", to.name);
        }
    }
    next();
});

exports.default = router;

/***/ })

},[172]);


// WEBPACK FOOTER //
// static/js/app.f7ac19952e8c29ea5c46.js